export const ids = ['uploaded', 'running', 'completed', 'failed'] as const;
